import type { ReactNode } from 'react';

/**
 * The card table layout, one place for every trick game. Slots: `top` (the seat across), `left` and
 * `right` (the sides), `center` (the trick) and `bottom` (you and your hand, full width). On a wide
 * screen it is a landscape felt with the sides beside the trick; on a phone the two sides sit in one
 * row above the trick, so nothing is squeezed into a narrow column.
 */
export function CardTable({
  top,
  left,
  right,
  center,
  bottom,
}: {
  readonly top: ReactNode;
  readonly left: ReactNode;
  readonly right: ReactNode;
  readonly center: ReactNode;
  readonly bottom: ReactNode;
}) {
  return (
    <div
      className="flex flex-col gap-4 rounded-[2rem] bg-gradient-to-b from-emerald-700/25 to-emerald-900/30 p-2 shadow-inner ring-1 ring-emerald-900/20 sm:p-5 lg:gap-6 lg:p-8 dark:from-emerald-700/20 dark:to-emerald-950/50"
      data-testid="card-table"
    >
      <div className="flex justify-center">{top}</div>
      <div className="grid grid-cols-2 items-start gap-3 lg:grid-cols-[1fr_auto_1fr] lg:items-center lg:gap-8">
        <div className="flex justify-start lg:justify-center">{left}</div>
        <div className="order-last col-span-2 lg:order-none lg:col-span-1">{center}</div>
        <div className="flex justify-end lg:justify-center">{right}</div>
      </div>
      <div>{bottom}</div>
    </div>
  );
}
